var render, staticRenderFns
import script from "./yd-render.vue?vue&type=script&lang=js"
export * from "./yd-render.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0173685b')) {
      api.createRecord('0173685b', component.options)
    } else {
      api.reload('0173685b', component.options)
    }
    
  }
}
component.options.__file = "src/components/com-public/com-yd-table/yd-render.vue"
export default component.exports